var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAimedic = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 182,
  height: 30,
  viewBox: "0 0 182 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1356_34519)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_1356_34519",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 182,
  height: 30
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M182 0H0V30H182V0Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1356_34519)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.4746 6.23633H23.394V13.2399H16.4746V6.23633Z",
  fill: "#CC132C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.394 6.23653L22.5518 0.0854492L16.4746 6.23653H23.394Z",
  fill: "#F27179"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.4702 7.08894C27.7911 4.20546 25.4049 1.78502 22.5508 0.0854492L23.393 6.23653L29.4702 7.08894Z",
  fill: "#F48587"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.3926 13.2399L29.4698 7.08874L23.3926 6.23633V13.2399Z",
  fill: "#E54D59"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9963 13.2399V6.23633H6.08203V13.2399H12.9963Z",
  fill: "#CC132C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9963 6.23653L6.91901 0.0854492L6.08203 6.23653H12.9963Z",
  fill: "#E54D59"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.08244 6.23633L0 7.08874L6.08244 13.2399V6.23633Z",
  fill: "#F27179"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.91942 0.0854492C4.06535 1.78502 1.67917 4.20019 0 7.08894L6.07724 6.23653L6.91942 0.0854492Z",
  fill: "#F48587"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9963 16.7603H6.08203V23.7637H12.9963V16.7603Z",
  fill: "#CC132C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.08203 23.7637L6.91901 29.9147L12.9963 23.7637H6.08203Z",
  fill: "#F27179"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-0.000660715 22.9111C1.67851 25.7999 4.06469 28.2151 6.91876 29.9146L6.07658 23.7636L-0.00585938 22.9111H-0.000660715Z",
  fill: "#F48587"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.08244 16.7603L0 22.9113L6.08244 23.7637V16.7603Z",
  fill: "#E54D59"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.4746 16.7603H23.394V23.7637H16.4746V16.7603Z",
  fill: "#CC132C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.4746 23.7637L22.5518 29.9147L23.394 23.7637H16.4746Z",
  fill: "#E54D59"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.4698 22.9113L23.3926 16.7603V23.7637L29.4698 22.9113Z",
  fill: "#F27179"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.4702 22.9111L23.393 23.7636L22.5508 29.9146C25.4049 28.2151 27.7911 25.7999 29.4702 22.9111Z",
  fill: "#F48587"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.226 1.70068C66.5104 1.70068 65.1172 3.10559 65.1172 4.84726C65.1172 6.58892 66.5104 7.99383 68.226 7.99383C69.9415 7.99383 71.3348 6.58366 71.3348 4.84726C71.3348 3.11085 69.9415 1.70068 68.226 1.70068Z",
  fill: "#CC132C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.6758 12.4823C70.6758 12.4823 70.6758 12.4665 70.6758 12.456C70.6758 11.0879 69.5789 9.98291 68.2325 9.98291C66.886 9.98291 65.8671 11.0247 65.7995 12.3297C65.7995 12.3455 65.7891 12.3507 65.7891 12.3665V25.9525C65.7891 27.3154 66.886 28.4256 68.2325 28.4256C69.5789 28.4256 70.6758 27.3206 70.6758 25.9525V12.4876C70.6758 12.4876 70.6758 12.4876 70.6758 12.4771V12.4823Z",
  fill: "#808284"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.414 28.047H130.038C127.865 28.047 126.623 26.8209 126.623 24.6479V5.32113C126.623 3.15325 127.865 1.92725 130.038 1.92725H135.414C142.837 1.92725 147.807 6.92598 147.807 15.066C147.807 23.2061 142.588 28.0522 135.414 28.0522V28.047ZM135.102 5.75786H132.705C132.269 5.75786 131.962 6.01043 131.962 6.5103V23.4587C131.962 23.9585 132.274 24.2111 132.705 24.2111H135.102C139.916 24.2111 142.406 20.8119 142.406 15.0608C142.406 9.3096 139.916 5.75786 135.102 5.75786Z",
  fill: "#808284"
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.926 22.8851C179.572 22.8851 179.24 22.9851 178.948 23.1429C178.943 23.1429 178.928 23.1324 178.928 23.1324C177.347 24.1006 176.157 24.3373 173.926 24.3373C169.424 24.3373 166.903 20.754 166.903 15.0029C166.903 9.25171 169.456 5.66315 173.989 5.66315C176.037 5.66315 177.477 6.19459 179 7.13646C179.006 7.13646 179.016 7.13646 179.021 7.13646C179.292 7.26801 179.588 7.34694 179.91 7.34694C181.049 7.34694 181.969 6.41032 181.969 5.26324C181.969 4.63184 181.688 4.07408 181.251 3.69522V3.68471C179.094 1.92199 176.739 1.57471 173.984 1.57471C166.685 1.57471 161.496 6.63659 161.496 14.9976C161.496 23.3587 166.654 28.4206 173.921 28.4206C176.469 28.4206 178.787 28.0259 180.726 26.9157C180.861 26.8578 180.986 26.7788 181.106 26.6946C181.111 26.6946 181.116 26.6894 181.127 26.6841V26.6788C181.646 26.3 181.984 25.6844 181.984 24.9846C181.984 23.827 181.059 22.8851 179.91 22.8851H179.926Z",
  fill: "#808284"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.6242 1.92188C96.5013 1.92188 95.5447 2.59013 95.0924 3.55305H95.0873L88.7813 15.4342C88.7813 15.4342 88.5213 15.9289 88.1678 15.9289C87.8143 15.9289 87.5388 15.4448 87.5388 15.4448L81.1288 3.47412C81.1288 3.47412 81.1288 3.47412 81.1236 3.47412C80.6558 2.55329 79.7252 1.92188 78.6335 1.92188C77.0843 1.92188 75.8262 3.19524 75.8262 4.76326V25.6369C75.8262 25.6369 75.8314 25.6474 75.8314 25.6527C75.8314 25.6738 75.8262 25.6896 75.8262 25.7106C75.8262 27.005 76.8607 28.0574 78.1396 28.0574C79.4185 28.0574 80.4582 27.005 80.4582 25.7106C80.4582 25.6896 80.453 25.6685 80.453 25.6422C80.453 25.6422 80.453 25.6369 80.453 25.6317V13.0033C80.453 13.0033 80.4738 12.5455 80.8533 12.4772C81.1444 12.4245 81.3108 12.5455 81.4356 12.8244L85.1786 20.1173C85.6985 21.217 86.8006 21.9747 88.0794 21.9747C89.3583 21.9747 90.4137 21.2485 90.9439 20.1909C90.9439 20.1909 90.9439 20.1909 90.9491 20.1909L94.8013 12.8297C94.9209 12.5507 95.0873 12.4298 95.3836 12.4824C95.7631 12.5507 95.7839 13.0085 95.7839 13.0085V25.7106C95.7839 27.005 96.8184 28.0574 98.0973 28.0574C99.3762 28.0574 100.41 27.005 100.41 25.7106V4.76326C100.41 3.19524 99.1526 1.92188 97.6034 1.92188H97.6242Z",
  fill: "#808284"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.437 24.2689C120.437 24.2689 120.417 24.2584 120.406 24.2584H120.349C120.349 24.2584 120.323 24.2584 120.307 24.2584C120.292 24.2584 120.281 24.2584 120.266 24.2584H110.934C110.498 24.2584 110.191 24.0057 110.191 23.5058V6.53124C110.191 6.02611 110.503 5.7788 110.934 5.7788H120.292C121.332 5.7788 122.174 4.92639 122.174 3.87402C122.174 2.82166 121.332 1.96924 120.292 1.96924H108.267C106.094 1.96924 104.852 3.19525 104.852 5.36312V24.695C104.852 26.8629 106.094 28.089 108.267 28.089H120.406C120.406 28.089 120.443 28.0784 120.458 28.0732C121.436 27.9942 122.205 27.1734 122.205 26.1684C122.205 25.1633 121.425 24.332 120.437 24.2636V24.2689Z",
  fill: "#808284"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.982 11.8877C114.267 11.8877 112.873 13.2978 112.873 15.0343C112.873 16.7707 114.267 18.1808 115.982 18.1808C117.698 18.1808 119.091 16.7707 119.091 15.0343C119.091 13.2978 117.698 11.8877 115.982 11.8877Z",
  fill: "#808284"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.632 1.70068C152.917 1.70068 151.523 3.10559 151.523 4.84726C151.523 6.58892 152.917 7.99383 154.632 7.99383C156.348 7.99383 157.741 6.58366 157.741 4.84726C157.741 3.11085 156.348 1.70068 154.632 1.70068Z",
  fill: "#CC132C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.081 12.4823C157.081 12.4823 157.081 12.4665 157.081 12.456C157.081 11.0879 155.984 9.98291 154.632 9.98291C153.281 9.98291 152.267 11.0247 152.199 12.3297C152.199 12.3455 152.189 12.3507 152.189 12.3665V25.9525C152.189 27.3154 153.286 28.4256 154.632 28.4256C155.979 28.4256 157.076 27.3206 157.076 25.9525V12.4876C157.076 12.4876 157.076 12.4876 157.076 12.4771L157.081 12.4823Z",
  fill: "#808284"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.224 15.1763C48.5084 15.1763 47.1152 16.5864 47.1152 18.3228C47.1152 20.0592 48.5084 21.4694 50.224 21.4694C51.9395 21.4694 53.3328 20.0644 53.3328 18.3228C53.3328 16.5811 51.9395 15.1763 50.224 15.1763Z",
  fill: "#808284"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.9771 25.3108L61.9926 25.3003L54.1894 4.66863C53.6955 2.94801 52.1307 1.69043 50.2696 1.69043C48.4085 1.69043 46.8489 2.94801 46.355 4.66863L38.5466 25.2266H38.557C38.4634 25.4844 38.4062 25.7581 38.4062 26.0422C38.4062 27.3471 39.4513 28.41 40.7457 28.41C41.7647 28.41 42.6224 27.747 42.9396 26.8314H42.95L42.9915 26.7209L49.0792 9.75681C49.0792 9.75681 49.4066 8.77285 50.2696 8.77285C51.1326 8.77285 51.429 9.83574 51.429 9.83574L57.5998 26.9578C57.5998 26.9578 57.6206 26.9788 57.6258 26.9893C57.9897 27.8207 58.8059 28.4047 59.7624 28.4047C61.0569 28.4047 62.1017 27.3471 62.1017 26.0369C62.1017 25.7791 62.0498 25.537 61.9771 25.3003V25.3108Z",
  fill: "#808284"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1356_34519"
}, /*#__PURE__*/React.createElement("rect", {
  width: 182,
  height: 30,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAimedic);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ed3d78ea72e11f9ab34d67166a58b13f.svg";